export default __webpack_public_path__ + "static/media/bl-big-01.b6c5ee4c.jpg";